// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"d32683d3c66a4aa50bed","293":"6a51f41bb45063fee49d"}[chunkId] + ".js";
};